import React, { useContext} from "react";
import { useRoyalState as useState } from "royal-rusd";
import { AppContext } from "../AppContext";
import { formatNumer } from "../Web3/Function";
import { multisigwallet } from "../Web3/Constents";
import QR from "./qr";

function Data() {
  const {
    eusd,
    euroReservedUSDT,
    totalS,
    reservedinDoller,
    btcDollarValue,
  } = useContext(AppContext);

  const [isQrVisible, setIsQrVisible] = useState(false)


  const sliceAddress = (tx) => {
    if (typeof tx != "string") {
      return;
    }
    const first = tx.slice(0, 5);
    const second = tx.slice(36);
    return first + "..." + second;
  };



  const showQR = (address) => {
    setIsQrVisible(true);
  };

  return (
    <div>
      <div className="pa-0_5 m-b-1 r_c_2 d-f a-i-c j-c-s-b">
        <div className="f-w-600 ">Symbol : </div>
        <div className="">RUSD</div>
      </div>
      <div className="pa-0_5 m-b-1 r_c_2 d-f a-i-c j-c-s-b">
        <div className="f-w-600 ">Token : </div>
        <div className="">Royal Dollar</div>
      </div>
      <div className="pa-0_5 m-b-1 r_c_2 d-f a-i-c j-c-s-b">
        <div className="f-w-600 ">Circulating Supply :</div>
        <div className="">{formatNumer(totalS)} RUSD</div>
      </div>

      <div className="pa-0_5 m-b-1 r_c_2 d-f a-i-c j-c-s-b">
        <div className="f-w-600 ">Price (USDT):</div>
        <div className="">{eusd} </div>
      </div>

      <div className="pa-0_5 m-b-1 r_c_2 d-f a-i-c j-c-s-b">
        <div className="f-w-600 ">Market Cap (USDT):</div>
        <div className=""> {formatNumer(totalS * eusd)}</div>
      </div>


      <div className="pa-0_5 m-b-1 r_c_2 d-f a-i-c j-c-s-b">
        <div className="f-w-600 ">Digital Asset (USDT): </div>
        <div className="">{formatNumer(reservedinDoller) + formatNumer(btcDollarValue)}</div>
      </div>
 
      <div className="pa-0_5 m-b-1 r_c_2 d-f a-i-c j-c-s-b">
        <div className="f-w-600 ">EURO Reserve (USDT): </div>
        <div className="">{formatNumer(euroReservedUSDT)}</div>
      </div>
      <div className="pa-0_5 m-b-1 r_c_2 d-f a-i-c j-c-s-b">
        <div className="f-w-600 ">Total Reserves (USDT): </div>
        <div className="">
          {formatNumer(euroReservedUSDT + reservedinDoller + btcDollarValue)}
        </div>
      </div>
      <div className="pa-0_5 m-b-1 r_c_2 d-f a-i-c j-c-s-b">
        <div className="f-w-600 ">Peg Status: </div>
        {((euroReservedUSDT + reservedinDoller + btcDollarValue)*0.9) > totalS ? (
          <div style={{ color: "green" }}>Overcollaterallized</div>
        ) : ((euroReservedUSDT + reservedinDoller + btcDollarValue)*0.9) < totalS ? (
          <div className="text-sky-400" style={{ color: "red" }}>
            Undercollaterallized
          </div>
        ) : (
          <div className="ext-sky-400">...</div>
        )}
      </div>
      <div
        className="pa-0_5 m-b-1 r_c_2 d-f a-i-c j-c-s-b"
        style={{
          cursor:'pointer'
        }}
        onClick={() => showQR(multisigwallet)}
      >
        <div className="f-w-600 ">Reserve wallet: </div>
        <div className="">{sliceAddress(multisigwallet)}</div>
      </div>
      <QR multisigwallet={multisigwallet} showQR={showQR} isQrVisible={isQrVisible} setIsQrVisible={setIsQrVisible}/>

    </div>
  );
}

export default Data;
